import { hashCodeq5arwsb9dgti as hashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _Buffer___init__impl__mrnqm7(value) {
  return value;
}
function _Buffer___get_value__impl__xxr8tn($this) {
  return $this;
}
function Buffer__hashCode_impl_3ylui6($this) {
  return hashCode($this);
}
//region block: exports
export {
  _Buffer___init__impl__mrnqm7 as _Buffer___init__impl__mrnqm713a81rxm7jha5,
  Buffer__hashCode_impl_3ylui6 as Buffer__hashCode_impl_3ylui622wuptpt1c13u,
  _Buffer___get_value__impl__xxr8tn as _Buffer___get_value__impl__xxr8tn1ccq9gbxoe825,
};
//endregion

//# sourceMappingURL=-Buffer.mjs.map
